import { useEntityFromRoute } from '@/common/hooks/route/useEntityFromRoute';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useImperativeHandle, useMemo, useState } from 'react';

export const TheraSelect = ({ entityPerspectiveRef, ref }) => {
  const module = useModuleFromRoute();
  const entity = useEntityFromRoute();

  const rsrc = useRsrc();

  const resetTherapuetic = useMemo(() => ({ name: 'None', hiers: [] }), []);

  const [therapuetics, setTherapuetics] = useState();
  const [selectedTherapuetic, setSelectedTherapuetic] = useState(resetTherapuetic);

  useEffect(() => {
    rsrc.data(module, 'THERA_SELECT_OPTIONS_DATA_PLUGIN', { entity: entity }, entity).then((therapuetics) => {
      setTherapuetics(therapuetics);
    });
  }, []);

  useImperativeHandle(ref, () => ({
    reset: () => setSelectedTherapuetic(resetTherapuetic),
  }));

  const handleChange = (e) => {
    let value = e.target.value;
    setSelectedTherapuetic(value);

    let reqParam = {
      entity,
      value,
    };

    rsrc.data(module, 'THERA_SELECT_PROD_DATA_PLUGIN', reqParam, entity).then((ids) => {
      entityPerspectiveRef.current.setDimFilter('PROD', ids);
    });
  };

  return (
    therapuetics && (
      <FormControl sx={{ width: 200 }}>
        <InputLabel>Therapuetics Selection</InputLabel>
        <Select onChange={handleChange} value={selectedTherapuetic}>
          <MenuItem key={resetTherapuetic.name} value={resetTherapuetic}>
            {resetTherapuetic.name}
          </MenuItem>
          {therapuetics.map((therapuetic) => {
            // When there is a group with leaf nodes
            if (therapuetic.hiers?.length) {
              return [
                <MenuItem key={therapuetic.name} value={therapuetic}>
                  {therapuetic.name}
                </MenuItem>,
                therapuetic.hiers.map((child) => (
                  <MenuItem key={child.name} value={child} sx={{ pl: 4 }}>
                    {child.name}
                  </MenuItem>
                )),
              ];
            }

            // There are no leaf nodes
            return (
              <MenuItem key={therapuetic.name} value={therapuetic}>
                {therapuetic.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    )
  );
};
